import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import HttpService from '../../service/HttpService';
import Header from '../../component/Header';

export default class General extends React.Component {
  http = new HttpService();
  loader = null;
  lo = require( 'lodash' );
  toPost = {};
  
  constructor( props ) {
    super( props );

    this.state = {
      general: {}
    };
  }

  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando configuración general...' );
    
    this.http
      .getGeneral()
      .then( general => {
        this.setState({ general: general });

        loader.finish();
      })
      .catch( this.errorHandler );
  }

  errorHandler = ( error ) => {
    this.refs.header.dialog().show( error );
  }

  updateItem = ( item ) => {
    let {general} = this.state;
    
    general[item.target.name] = item.target.value;

    this.setState({ general: general });
  }

  saveItemHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .saveGeneral( this.state.general )
      .then( ( general ) => {
        this.setState({ general: general });
        
        loader.finish();
      })
      .catch( this.errorHandler );

    this.setState({ showPanel: false });
  }

  render() {
    const menuItems = [
      {
        text: 'Guardar',
        iconProps: {
          iconName: 'Save'
        },
        onClick: this.saveItemHandler
      }
    ];
    const menuFarItems = [
      {
        iconProps: {
          iconName: 'Info'
        }
      }
    ];
    const customItems = [];

    return (
      <Fabric>
        <Header title="Clientes" ref="header" visible={false}/>

        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <CommandBar
                  items={ menuItems }
                  overflowItems={ customItems }
                  farItems={ menuFarItems }
                />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="company" label="Nombre de la empresa" value={ this.state.general.company } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="whatsapp" label="Whatsapp" value={ this.state.general.whatsapp } onChange={ this.updateItem }/>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg6">
              <TextField name="email" label="Email" value={ this.state.general.email } onChange={ this.updateItem }/>
            </div>
          </div>
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/settings/General.jsx